<template>
  <div class="user-visits-sector-page">
    <img src="../assets/face logo.png">

    <div class="title">
      Sector: {{ sector }}
    </div>
    <div>
      <q-r-code-scanner @codeScanned="onCodeScanned"/>
    </div>

    <div class="notifications-container">
        <notifications group="user-visits" />
    </div>
  </div>
</template>

<script>
  import {verifyUser} from "../services/graphql";
  import { addUserVisit, updateUserVisitSector } from "../services/graphql";
  import QRCodeScanner from "../components/QRCodeScanner";

  export default {
    name: "UserVisitsSectorPage",
    components: {QRCodeScanner},
    props: {
      sector:{
        type: String,
        required: true,
      }
    },

    data() {
      return {
        scanner: null
      };
    },

    methods: {

      onCodeScanned(content) {
        try {
          let user = JSON.parse(content);
          this.addNewVisit(user.phone);
        } catch (e) {
          this.$notify({
            group: 'user-visits',
            title: 'Ungültiger Code',
            duration: 2000,
            type: 'warn'
          });
        }
      },

      addNewVisit(phone) {
        addUserVisit(phone.trim(), this.sector.toUpperCase())
          .then(response => {
            this.$notify({
                group: 'user-visits',
                title: 'Benutzer erfolgreich hinzugefügt',
                duration: 10000
            });
          })
          .catch(err => {
            if (
              err.graphQLErrors &&
              err.graphQLErrors.length
            ) {
              if (err.graphQLErrors[0].message === "User not found") {
                this.$emit("userNotExist", phone);
              }
              else if (err.graphQLErrors[0].message) {
                this.$notify({
                    group: 'user-visits',
                    title: err.graphQLErrors[0].message,
                    duration: -1,
                    type: 'warn'
                });
              }
            }
          });
      }
    },
  };
</script>

<style lang="scss">
  @import "UserVisitsSectorPage";
</style>
